import { alpha, darken, Skeleton } from "@mui/material";
import { MAX_CONTENT_WIDTH } from "helpers/breakpoints";
import { COLOR_BLACK, COLOR_BLACK_LIGHTER, COLOR_WHITE } from "helpers/colors";
import { FONT_FAMILY_GRAPHIK } from "helpers/FONT";
import { SPACING } from "helpers/spacings";
import React from "react";

export default function LeaderboardIntroBanner({ data, teamData, effectiveView, viewSet }) {
  const colorDarken = darken(COLOR_BLACK_LIGHTER, 0.5);

  const isTeams = effectiveView === "teams";
  const title = isTeams
    ? (teamData?.name ?? <Skeleton style={{ backgroundColor: alpha(COLOR_WHITE, 0.2), width: 300 }} />)
    : "Leaderboards";

  return (
    <div
      style={{
        color: COLOR_WHITE,
        background: `linear-gradient(0deg, ${COLOR_BLACK_LIGHTER}, ${colorDarken})`,
        display: "flex",
        flexFlow: "row wrap",
        alignItems: "center",
        padding: SPACING,
        gap: 40,
      }}
    >
      <div
        style={{
          display: "flex",
          flexFlow: "column nowrap",
          gap: 10,
          margin: "0 auto",
          maxWidth: MAX_CONTENT_WIDTH,
          width: `calc(100vw - ${SPACING} * 2)`,
        }}
      >
        <div
          style={{
            display: "flex",
            flexFlow: "row nowrap",
            alignItems: "flex-start",
            justifyContent: "space-between",
          }}
        >
          <h1
            style={{
              margin: 0,
              fontSize: `min(44px, 10vw)`,
              textTransform: "uppercase",
              fontFamily: FONT_FAMILY_GRAPHIK,
              fontWeight: 800,
            }}
          >
            {title}
          </h1>
        </div>

        <div
          style={{
            display: "flex",
            flexFlow: "row wrap",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 12,
          }}
        >
          <div
            style={{
              fontFamily: FONT_FAMILY_GRAPHIK,
              fontSize: 12,
              opacity: 0.6,
            }}
          >
            {!isTeams &&
              (data?.season?.nameWithLeague ?? (
                <Skeleton style={{ backgroundColor: alpha(COLOR_WHITE, 0.2), width: 260 }} />
              ))}
          </div>

          {/* League / Teams toggle */}
          <div
            style={{
              display: "flex",
              flexFlow: "row nowrap",
              flexShrink: 0,
              background: alpha(COLOR_WHITE, 0.15),
              borderRadius: 6,
              gap: 2,
            }}
          >
            {["league", "teams"].map((v) => (
              <button
                key={v}
                onClick={() => viewSet(v === "league" ? null : v)}
                style={{
                  background: effectiveView === v ? COLOR_WHITE : "transparent",
                  color: effectiveView === v ? COLOR_BLACK : COLOR_WHITE,
                  border: "none",
                  borderRadius: 6,
                  fontFamily: FONT_FAMILY_GRAPHIK,
                  fontWeight: effectiveView === v ? 600 : 400,
                  fontSize: 14,
                  textTransform: "capitalize",
                  cursor: "pointer",
                  padding: `10px 14px`,
                  transition: "background 0.15s, color 0.15s",
                }}
              >
                {v === "league" ? "League" : "Teams"}
              </button>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
